import { useContext, useState } from "react";
import { AsyncPaginate, wrapMenuList } from "react-select-async-paginate";
import { components } from "react-select";
import { useTheme } from "context/ThemeContext";
import { AuthContext } from "context/AuthContext";
import { t } from "i18next";

const CustomControl = (props) => {
  const { selectProps } = props;

  const handleClick = (e) => {
    e.stopPropagation(); // Prevent focus-triggered open

    selectProps.setMenuOpen(
      selectProps.menuOpen === "showSelected" ? true : !selectProps.menuOpen
    ); // Toggle open/close
  };

  return (
    <div onClick={handleClick}>
      <components.Control {...props} />
    </div>
  );
};

const MenuList = (props) => {
  const { selectProps } = props;
  if (Array.isArray(selectProps.value) && selectProps.value?.length > 0) {
    return (
      <div>
        <components.MenuList {...props} isMulti={true}>
          <div className="text-center font-semibold">
            {t("_Selected_Entries")}
          </div>
          {selectProps.value.map((option) => {
            const { innerRef, innerProps } = props;
            return (
              <div ref={innerRef} {...innerProps}>
                {option.value !== "" && (
                  <components.Option
                    {...props}
                    key={option.value}
                    innerRef={null}
                    isDisabled={option.disabled}
                    // isSelected={props.getValue().some((v) => v.value === option.value)}
                    isFocused={false}
                    innerProps={{
                      id: option.value,
                      onClick: () =>
                        props.setValue(
                          selectProps.value?.filter(
                            (val) => val.value !== option.value
                          )
                        ),
                    }}
                  >
                    <div className="flex items-center w-full p-1 cursor-pointer mr-2">
                      <input
                        type="checkbox"
                        checked={true}
                        readOnly
                        className="rounded-md h-5 w-5 shadow-none outline-none checked:shadow-none checked:outline-none focus:ring-0 focus:ring-opacity-0 focus:ring-transparent"
                        style={{ marginRight: 8 }}
                      />
                      <span>{option.label}</span>
                    </div>
                  </components.Option>
                )}
              </div>
            );
          })}
        </components.MenuList>
      </div>
    );
  }
  return null;
};

const CustomMultiValue = (props) => {
  const selected = props.getValue();

  if (props.index === 0) {
    const label =
      props.data.label.length > 5
        ? props.data.label.slice(0, 5) + "..."
        : props.data.label;

    const extra = selected.length - 1;
    const { selectProps } = props;

    return (
      <>
        <components.MultiValue {...props}>
          <span>{label}</span>
        </components.MultiValue>
        {extra > 0 && (
          <div
            onClick={(e) => {
              e.stopPropagation();
              selectProps.setMenuOpen("showSelected");
            }}
            style={{
              cursor: "pointer",
              padding: "3px 6px",
              backgroundColor: "#eee",
              borderRadius: "4px",
              fontSize: "0.85em",
              height: "24px",
              display: "flex",
              alignItems: "center",
              marginLeft: "4px",
            }}
          >
            +{extra}
          </div>
        )}
      </>
    );
  }

  return null;
};

const CustomOption = (props) => {
  const { isSelected, label, innerRef, innerProps } = props;

  return (
    <div ref={innerRef} {...innerProps}>
      <components.Option {...props}>
        <div className="flex items-center w-full p-1 cursor-pointer mr-2">
          <input
            type="checkbox"
            checked={isSelected}
            readOnly
            className="rounded-md h-5 w-5 shadow-none outline-none checked:shadow-none checked:outline-none focus:ring-0 focus:ring-opacity-0 focus:ring-transparent"
            style={{ marginRight: 8 }}
          />
          <span>{label}</span>
        </div>
      </components.Option>
    </div>
  );
};

const MultiSelectPaginatedDropDown = (props) => {
  const { userDetails } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  // const [options, setOptions] = useState([]);
  const {
    values,
    setValues,
    token,
    cacheUniqs = [],
    isDisabled = false,
    name,
    placeholder,
    otherProps,
    setFieldTouched,
    handleOnchange,
    apiCall,
    selectedChannel,
    loadOptions,
  } = props;
  const { theme } = useTheme();

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "2.75rem",
      backgroundColor: "inherit",
      borderRadius: "0.25rem",
      border: state.isFocused
        ? `1px solid ${theme.secondaryColor}`
        : "1px solid #cacaca",
      boxShadow: state.isFocused ? `0 0 2px ${theme.secondaryColor}` : "none",
      "&:hover": {
        borderColor: theme.secondaryColor,
        boxShadow: `0 0 2px ${theme.secondaryColor}`,
      },
      paddingRight: "0.5rem",
    }),
    menu: (base) => ({
      ...base,
      width: "100%",
      marginTop: 5,
      zIndex: 99,
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "transparent"
        : state.isFocused
        ? "#f0f0f0"
        : "transparent",
      color: "#000",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 150,
      padding: 0,
    }),
    valueContainer: (base) => ({
      ...base,
      height: 40,
      padding: "0 8px",
      overflow: "hidden",
      display: "flex",
      flexWrap: "nowrap",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 40,
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#ddd",
      borderRadius: "4px",
      padding: "0 4px",
      marginRight: "4px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    }),
    placeholder: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      fontSize: "14px",
      fontWeight: "400",
      color: "#CACACA",
    }),
    input: (data) => ({
      ...data,
      "input:focus": {
        boxShadow: "none",
      },
      boxShadow: "0 !important",
      "&:hover": {
        border: "0 !important",
      },
    }),
  };

  const optionsToLoad = async (search, prevOptions, { page: pgIndex }) => {
    let apiResponse;
    apiResponse = await apiCall(
      userDetails.token,
      pgIndex,
      selectedChannel,
      search
    );

    return {
      options: apiResponse.options,
      hasMore: apiResponse.hasMore,
      additional: { page: pgIndex + 1 },
    };
  };

  return (
    <AsyncPaginate
      name={name}
      placeholder={placeholder ? placeholder : "Select ..."}
      value={values}
      menuIsOpen={Boolean(menuOpen)}
      openMenuOnClick={false}
      openMenuOnFocus={false}
      setMenuOpen={setMenuOpen}
      onMenuClose={setMenuOpen}
      menuOpen={menuOpen}
      loadOptions={loadOptions ? loadOptions : optionsToLoad}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      styles={customStyles}
      components={{
        IndicatorSeparator: () => null,
        MultiValue: CustomMultiValue,
        Option: CustomOption,
        Control: CustomControl,
        ...(menuOpen === "showSelected"
          ? { MenuList: wrapMenuList(MenuList) }
          : {}),
      }}
      additional={{ page: 1 }}
      onBlur={() => setFieldTouched(name, true)}
      isDisabled={isDisabled}
      {...otherProps}
      onChange={(e) => {
        setValues((prevValues) => ({
          ...prevValues,
          [name]: e,
        }));
      }}
      getOptionValue={(option) => option.value}
      getOptionLabel={(option) => option.label}
      debounceTimeout={500}
      cacheUniqs={cacheUniqs ? cacheUniqs : [apiCall]}
    />
  );
};

export default MultiSelectPaginatedDropDown;
